import { render, staticRenderFns } from "./CardListWidget-Card.vue?vue&type=template&id=67cc8a0c&"
import script from "./CardListWidget-Card.vue?vue&type=script&lang=js&"
export * from "./CardListWidget-Card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports